import type { LocationJson } from 'app/types/entities'

/**
 * Which inbox to open: last used, then busiest, then first by name.
 *
 * `locations` is already narrowed to the Inbox-entitled locations of the current
 * workspace, so a revoked product or a workspace switch reaches this as a
 * `savedId` that is not in the list, and falls through rather than opening an
 * inbox the user can no longer see. The list arrives name-sorted from
 * `inboxEnabledLocations`, which is what both fallbacks read off.
 */
export function resolveInboxLocationId(
  locations: LocationJson[],
  savedId: string | undefined,
  unreadByLocation: Record<string, number>,
): string | undefined {
  if (locations.length === 0) return undefined
  if (savedId && locations.some((location) => location.id === savedId)) return savedId

  let busiest: LocationJson | undefined
  let busiestUnread = 0
  for (const location of locations) {
    const unread = unreadByLocation[location.id ?? ``] ?? 0
    // Strictly greater, so an unread tie keeps the earlier name.
    if (unread > busiestUnread) {
      busiest = location
      busiestUnread = unread
    }
  }
  return busiest?.id ?? locations[0].id
}
